<template>
  <div class="App" id="app">
    <Header @openSignUp="openSignUp" />
    <router-view/>
    <Footer />
    <ModalSignup />
    <CookieBanner />
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import ModalSignup from '@/components/ModalSignup'
  import CookieBanner from '@/components/CookieBanner'

  export default {
    components: {
      Header,
      Footer,
      ModalSignup,
      CookieBanner
    },
    methods: {
      openSignUp() {
        // document.body.style.overflow = "hidden";
        document.querySelector('#ModalSignup').classList.remove("hidden")
      }
    },
    updated() {
      // console.log(document.title);
      // send page_view Google analytics
      if (this.$ga) {
        this.$ga.logEvent('config', this.$ga.app.options_.measurementId, {
            'page_title': document.title,
            'page_path': this.$route.fullPath
          }
        )
      }
    }
  }
</script>

<style>
  body {
    background-color: rgb(25, 34, 37);
    /* background-color: #173363; */
    color: rgb(250, 255, 240);
    font-size: 21px;
    line-height: 30px;
    padding: 0 3rem;
    /* background-image: linear-gradient(50deg, rgb(0, 17, 38), rgb(16, 66, 68)); */
    background-image: linear-gradient(70deg, rgb(5, 10, 15), rgb(44, 56, 60));

    /* background-blend-mode: overlay;
    background-image: url('https://images.unsplash.com/photo-1576606218207-20245d50d0b9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80');
    background-position: top;
    background-position-y: -950px;
    background-repeat: no-repeat;
    background-size: contain; */
  }
  body, ul {
    margin: 0;
  }
  h1, h2, h3 {
    font-weight: normal;
  }
  h1 {
    font-size: 160%;
    /* padding: 0 3rem; */
  }
  h2 {
    font-size: 130%;
    line-height: 140%;
  }
  h3 {
    font-size: 120%;
  }
  hr {
    height: 1px;
    border: 0;
    background: rgb(45, 65, 68);
  }
  p {
    line-height: 150%;
  }
  p, ul, ol, table {
    max-width: 55rem;
  }
  p, ul, ol {
    margin: 0 0 2rem;
  }
  h1, h2, h3 {
    margin-top: 2rem;
  }
  td > p {
    margin-bottom: 0;
  }
  td {
    margin-bottom: 0.5rem;
  }
  td:first-of-type {
    padding-right: 2rem;
  }
  tr:not(:last-child) td {
    border-bottom: 1px solid rgb(45, 65, 68);
    padding-bottom: 1rem;
  }
  table {
    border-collapse: separate;
    border-spacing: 0 1rem;
  }
  tbody {
    vertical-align: top;
  }
  h1+h2, h1+h3,
  h2+h3,
  p+h2, p+h3, p+h4,
  ul+h2, ul+h3, ul+h4,
  ol+h2, ol+h3, ol+h4,
  table+h2, table+h3, table+h4
  {
    margin: 3rem 0 0.5rem;
  }

  ul, ol {
    padding: 0;
  }
  li {
    margin-left: 2rem;
    margin-bottom: 0.5rem;
  }

  a {
    color: rgb(18, 119, 255);
  }
  a:visited {
    color: rgb(18, 119, 255);
  }
  a:hover {
    color: rgb(190, 0, 0);
  }
  .App {
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* color: rgb(161, 182, 171); */
  }

  .center {
    text-align: center;
  }

  .error-page {
    padding: 10rem 0 15rem;
  }

  .hidden {
    display: none;
  }

  .subscribe-link {
    background-color: rgb(0, 102, 255);
    color: #fff;
    padding: 0 0.5rem;
    border-radius: 4px;
    display: inline-block;
    line-height: 26px;
    height: 29px;
  }
  .subscribe-link:hover {
    background-color: rgb(232, 162, 57);
    color: #000;
  }
  .subscribe-link:visited {
    color: #fff;
  }
  .subscribe-link:visited:hover {
    color: #000;
  }

  .disclaimer {
    padding: 1rem 1.5rem 1.5rem;
    background-color: rgb(61, 77, 110);
  }
</style>
